import { View } from "@aws-amplify/ui-react";

import HeaderImage from "../assets/baptize-america-header.svg";
import { Box } from "@mui/material";

export function Header() {
  return (
    <View
      style={{
        textAlign: "center",
      }}
    >
      <Box
        component="img"
        sx={{
          width: 225,
          height: 75,
          margin: "2rem",
        }}
        alt="Baptize America"
        src={HeaderImage}
      />
    </View>
  );
}
